import React from 'react';
import './About.css';

const About = () => {
    return (
        <div>
            <h1>about</h1>
        </div>
    );
};

export default About;